export default __webpack_public_path__ + "static/media/g2019-3.6403d72c.jpeg";